export enum PriceListType {
    Default = 1,
    Option = 2
}